import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ChangepassowrdComponent } from '../changepassowrd/changepassowrd.component';
import { AppService } from 'src/app/appservice.service';

@Component({
  selector: 'app-update-org',
  templateUrl: './update-org.component.html',
  styleUrls: ['./update-org.component.css']
})
export class UpdateOrgComponent implements OnInit {

  orgForm: FormGroup;
  isAddress = false;
  isSubmitting = false;

  constructor(public dialogRef: MatDialogRef<ChangepassowrdComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public service: AppService) {
    this.orgForm = new FormGroup({
      name: new FormControl(data.name),
      shortname: new FormControl(),
      slogan: new FormControl(),
      phone: new FormControl(),
      mobile: new FormControl(),
      email: new FormControl(),
      website: new FormControl(),
      addressline1: new FormControl(),
      addressline2: new FormControl(),
      landmark: new FormControl(),
      pinCode: new FormControl(),
      city: new FormControl(),
      stateId: new FormControl(),
      country: new FormControl(),
      gstin: new FormControl(),
      pan: new FormControl(),
      bankname: new FormControl(),
      bankacno: new FormControl(),
      branch: new FormControl(),
      ifsc: new FormControl(),
      upiid: new FormControl(),
      demo1: new FormControl(),
      demo2: new FormControl(),
      demo3: new FormControl(),
      demo4: new FormControl(),
      demo5: new FormControl()
    });
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onSubmit() {
    try {
      this.isSubmitting = true;
      if (this.orgForm.valid) {
        this.service.getRequestData('api/org/update', this.orgForm.value).subscribe((data) => {
          console.log(data);
          if (data.Success) {
            this.data.name = this.orgForm.controls.name.value;
            this.dialogRef.close(data.data);
          } else {
            this.service.sendMessage(data.message);
          }
        },
          (err) => {
            console.log('Update ORG failed : ' + err);
            this.service.sendMessage('Oops');
          });
      } else {
        this.service.sendMessage('Org.FillAllDetails');
      }
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }
  }
}

export interface DialogData {
  name: string;
}
